import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ICalendarInit } from '../interfaces/calendar.interfaces';

@Injectable({
    providedIn: 'root',
})
export class CalendarService {
    public initSubject = new Subject<ICalendarInit>();

    public setParams(num: ICalendarInit) {
        if (this.initSubject) {
            this.initSubject.next(num);
        }
    }

    // Событие инициализации
    public onInit$(): Observable<ICalendarInit> {
        return this.initSubject.asObservable();
    }

    // Событие, отмены выбора
    public notSelectSubject = new Subject<boolean>();

    public notSelect(num: boolean) {
        // Отменить выбор в календаре
        if (this.notSelectSubject) {
            this.notSelectSubject.next(num);
        }
    }

    // Событие - отмена выбранной даты
    public onNotSelect$(): Observable<boolean> {
        return this.notSelectSubject.asObservable();
    }

    // Устанока выбранной даты
    public setSDSubject = new Subject<string>();

    public setSelectedDate(dt: string) {
        // Отменить выбор в календаре
        this.setSDSubject.next(dt);
    }

    public onSelectedDate$(): Observable<string> {
        return this.setSDSubject.asObservable();
    }
}
